<div class="d-lg-flex flex-wrap align-items-center pt-4" rt="inventory-images-header">
  <h3>Listing Photos</h3>
  <div class="ml-auto d-flex align-items-center" *ngIf="showAdminActions || allowBatchUpload">
    <button
      type="button"
      class="btn btn-batch-upload mr-2"
      [disabled]="!listingImagesLoaded"
      (click)="multipleImagesInput.value = null; multipleImagesInput.click()"
      rt="inventory-images-batch-upload"
    >
      Upload Multiple Photos
    </button>
    <common-icon-button rt="inventory-images-download-photo" iconClass="icon-import" buttonText="Download all photos"
      (click)="downloadAllPhotos()" *ngIf="showAdminActions">
    </common-icon-button>
  </div>
</div>

<input class="d-none" type="file" accept="image/*" (change)="onMultipleImagesChange($event)" multiple #multipleImagesInput />

<div class="row">
  <div class="col-lg-6 col-xl-3 mt-3" *ngFor="let image of images; index as i">
    <div class="card">
      <div class="card-header d-flex">
        <div>
          {{ image.name }}
          <span *ngIf="inventoryItem.coverImagePosition == i">(Cover photo)</span>
        </div>
        <div class="ml-auto" *ngIf="imagePaths[i] != '' && imagePaths[i] != null">
          <div ngbDropdown placement="bottom-right" class="d-inline-block">
            <i class="icon-peapod text-green cursor-pointer" ngbDropdownToggle></i>
            <div ngbDropdownMenu>
              <button ngbDropdownItem (click)="updateCoverImage(i)">Make Cover</button>
              <button ngbDropdownItem (click)="editImage(image, i)">Edit</button>
              <button ngbDropdownItem (click)="deleteImage(i)">Delete</button>
            </div>
          </div>
        </div>
      </div>
      <div class="card-body listing-photo-drop-zone" [class.image-slot-drag-over]="dragOverSlotIndex === i"
        (dragover)="onListingSlotDragOver($event, i)" (dragleave)="onListingSlotDragLeave($event, i)"
        (drop)="onListingSlotDrop($event, i)">
        <img class="w-100 img-fit br-5" *ngIf="imagePaths[i] != '' && imagePaths[i] != null" [src]="imagePaths[i]"
          [attr.alt]="'Machine photo ' + (i + 1)" (load)="imgOnLoad($event, i)" />
        <div *ngIf="imagePaths[i] == '' || imagePaths[i] == null"
          class="d-flex justify-content-center align-items-center image-thumbnail-add"
          (click)="singleImageInput.value = null; setIndexForSingle(i); singleImageInput.click()">
          <figure>
            <i class="icon-large icon-stepper-add text-light-grey ml-3 mr-1 cursor-pointer text-green"
              rt="upload-image-component-add-image"></i>
            <figcaption>Add Photo</figcaption>
          </figure>
        </div>
      </div>
    </div>
  </div>

  <input class="d-none" type="file" accept="image/*" (change)="onSingleImageChange($event)" #singleImageInput />
</div>
<ng-template #modalContent let-modal>
  <div class="modal-header">
    <button type="button" class="btn btn-outline-secondary" data-dismiss="modal"
      (click)="modal.dismiss()">Close</button>
    <button type="button" class="btn btn-secondary" (click)="saveCroppedPhoto(modal)">Save photo</button>
  </div>

  <img style="max-width: 100%" [src]="imgCropperSrc" id="croppr" #croppr alt="Image to crop" (load)="imageLoadedForCropper($event)" />

  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" data-dismiss="modal" (click)="zoomOut()">Zoom Out</button>
    <button type="button" class="btn btn-outline-secondary" (click)="zoomIn()">Zoom In</button>
  </div>
</ng-template>

<!-- <common-edit-inventory-images></common-edit-inventory-images> -->